import { AxiosInstance } from "axios";
import { Region } from "../types/Region";
import { Crde } from "../types/Crde";

export const regionService = {
  getAllRegions: async (api: AxiosInstance): Promise<Region[]> => {
    try {
      const response = await api.get("/region");
      return response.data as Region[];
    } catch (error: any) {
      console.error("Erreur lors de la récupération des régions :", error);
      return [];
    }
  },

  getRegionById: async (api: AxiosInstance, idRegion: number): Promise<Region | null> => {
    try {
      const response = await api.get(`/region/${idRegion}`);
      return response.data as Region;
    } catch (error: any) {
      console.error(`Erreur lors de la récupération de la région ${idRegion}:`, error);
      return null;
    }
  },

  // If backend exposes CRDEs per region (based on DB), try calling `/region/{id}/crdes`.
  getCrdesByRegion: async (api: AxiosInstance, idRegion: number): Promise<Crde[]> => {
    try {
      const response = await api.get(`/region/${idRegion}/crdes`);
      return response.data as Crde[];
    } catch (error: any) {
      console.error(`Erreur lors de la récupération des CRDEs pour la région ${idRegion}:`, error);
      return [];
    }
  },
};
